import { CenterOlComment } from '../../../lib/types/models/center-ol-comment/center-ol-comment'
import { CenterOlCommentInput } from '../../../lib/types/models/center-ol-comment/center-ol-comment-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createCenterOlComment = async (
  input: CenterOlCommentInput & { centerId: number }
) => {
  const { centerId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.centers.createCenterOlComment.url, { centerId }))
    .post<CenterOlComment, CenterOlCommentInput>(data)
}
